import React from 'react'
import PropTypes from 'prop-types'

import './AnimatedBlob.css'

const AnimatedBlob = ({ hiddenMobile, right, color, modifier, style }) => (
  <div
    style={style}
    className={
      'fmbm-animatedblob' +
      (hiddenMobile ? ' fmbm-animatedblob--hidden-mobile' : '') +
      (right ? ' fmbm-animatedblob--right' : '') +
      (color ? ` fmbm-animatedblob--${color}` : '') +
      (modifier ? ` fmbm-animatedblob--${modifier}` : '')
    }
  />
)

AnimatedBlob.propTypes = {
  hiddenMobile: PropTypes.bool,
  right: PropTypes.bool,
  color: PropTypes.string,
  modifier: PropTypes.string,
}

export default AnimatedBlob



// WEBPACK FOOTER //
// ./src/Components/AnimatedBlob/AnimatedBlob.js